import { createContext, PropsWithChildren, useMemo } from "react";

import { EvaluationUpdateFormValue } from "./EvaluationUpdateFormContext.decl";

export const EvaluationUpdateFormContext =
  createContext<EvaluationUpdateFormValue | null>(null);

export function EvaluationUpdateFormProvider({
  children,
  form,
  ratingScales,
}: PropsWithChildren<EvaluationUpdateFormValue>) {
  const value = useMemo<EvaluationUpdateFormValue>(
    () => ({
      ratingScales,
      form,
    }),
    [form, ratingScales]
  );

  return (
    <EvaluationUpdateFormContext.Provider value={value}>
      {children}
    </EvaluationUpdateFormContext.Provider>
  );
}
